export interface IErrorReportingConfig {
	dsn: string;
	environment: string;
	sensitivePaths?: readonly string[];
}

export interface IErrorReportingBreadcrumb {
	data?: { url?: string };
	message?: string;
}

export interface IErrorReportingLog {
	attributes?: Record<string, unknown>;
}

export interface IErrorReportingClient {
	init: (options: {
		dsn: string;
		environment: string;
		sendDefaultPii: false;
		beforeBreadcrumb: (breadcrumb: IErrorReportingBreadcrumb) => unknown | null;
		beforeSendLog: (log: IErrorReportingLog) => IErrorReportingLog;
	}) => void;
	logger: {
		warn: (
			message: string,
			attributes: {
				flow: string;
				status: number;
				user?: string;
				domain?: string;
			}
		) => void;
		info: (
			message: string,
			attributes: {
				flow: string;
				action: string;
				user?: string;
				domain?: string;
			}
		) => void;
	};
	captureMessage: (
		message: string,
		captureContext: {
			level: 'error';
			tags: {
				flow: string;
				status: string;
				user?: string;
				domain?: string;
			};
		}
	) => void;
}

export interface IRequestFailureEvent {
	flow: string;
	status: number;
	user: string;
}

export interface IActionEvent {
	flow: string;
	action: string;
	user: string;
}

export interface IErrorReporting {
	init: (config: IErrorReportingConfig) => void;
	reportRequestFailure: (event: IRequestFailureEvent) => void;
	reportAction: (event: IActionEvent) => void;
}

export enum SensitiveLogKey {
	Password = 'password',
	Username = 'username',
	Email = 'email',
	Token = 'token',
	Authorization = 'authorization',
}
